import { render, staticRenderFns } from "./hqglBenefitsGrantAuditDetail.vue?vue&type=template&id=36619858&scoped=true&"
import script from "./hqglBenefitsGrantAuditDetail.vue?vue&type=script&lang=js&"
export * from "./hqglBenefitsGrantAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglBenefitsGrantAuditDetail.vue?vue&type=style&index=0&id=36619858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36619858",
  null
  
)

export default component.exports